import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: { type: String, default: "verbinde.." }
  }

  click() {
    this.element.classList.add("disabled")
    this.element.setAttribute("aria-disabled", "true")
    this.element.innerHTML = `<i class="fa-solid fa-spinner fa-spin"></i> ${this.textValue}`
  }
}
